<template>
  <section>
    <div class="flex-row gameplay_steps">
      <div
        v-for="(questionStep, index) in questionSteps"
        :key="questionStep.index"
        :class="[
          'game_step',
          {
          centered: (index > 0) &&  (index < (totalQuestions - 1)),
          correct: questionStep.answered && questionStep.correct,
          wrong: questionStep.answered && !questionStep.correct
        }]"></div>
    </div>

    <div class="flex-row quest_count">
      <p>{{ getTranslations.game_page_header_current_question_pt1 }} {{ currentQuestionIndex + 1 }} {{ getTranslations.game_page_header_current_question_pt2 }} {{ totalQuestions }}</p>

      <slot name="timer"></slot>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'GameHeader',
  props: {
    questionSteps: {
      type: Array,
      default: () => []
    },
    currentQuestionIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    totalQuestions () {
      return this.questionSteps.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/game/GameHeader.vue